<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：首页 > 项目展示
    </div>
    <div class="content-info">
      <h3 class="form-title flex-center">
        项目展示
      </h3>
      <div class="step-box">
        <div class="step-title">
          <div class="step-title-text">
            1.项目信息
          </div>
        </div>
        <div class="padding">
          <el-form ref="importInfo" :model="importInfo" :rules="rules" label-width="170px">
            <el-form-item label="项目名称：" class="margin-bottom-sm" prop="entry_name">
              <el-input v-model="importInfo.entry_name" placeholder="请输入项目名称"></el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="服务对象：" class="margin-bottom-sm" prop="service_object">
                  <el-input v-model="importInfo.service_object" placeholder="请输入服务对象"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务地点：" class="margin-bottom-sm" prop="service_address">
                  <el-input v-model="importInfo.service_address" placeholder="请输入服务地点"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="服务领域（可多选）：" class="margin-bottom-sm" prop="service_lingyu">
              <div class="input-container active">
                <el-checkbox-group v-model="importInfo.service_lingyu">
                  <el-checkbox label="扶贫" name="area"></el-checkbox>
                  <el-checkbox label="济困" name="area"></el-checkbox>
                  <el-checkbox label="扶老" name="area"></el-checkbox>
                  <el-checkbox label="救孤" name="area"></el-checkbox>
                  <el-checkbox label="恤病" name="area"></el-checkbox>
                  <el-checkbox label="助残" name="area"></el-checkbox>
                  <el-checkbox label="救灾" name="area"></el-checkbox>
                  <el-checkbox label="助医" name="area"></el-checkbox>
                  <el-checkbox label="助学" name="area"></el-checkbox>
                  <el-checkbox label="环境保护" name="area"></el-checkbox>
                  <el-checkbox label="社区治理与营造" name="area"></el-checkbox>
                  <el-checkbox label="会员服务" name="area"></el-checkbox>
                  <el-checkbox label="行业协调" name="area"></el-checkbox>
                  <el-checkbox label="行业自律" name="area"></el-checkbox>
                  <el-checkbox label="行业服务" name="area"></el-checkbox>
                  <el-checkbox label="疫情防控、复工复产" name="area"></el-checkbox>
                  <el-checkbox label="党群服务" name="area"></el-checkbox>
                  <el-checkbox label="社会心理" name="area"></el-checkbox>
                  <el-checkbox label="科技创新" name="area"></el-checkbox>
                  <el-checkbox label="对外交流" name="area"></el-checkbox>
                  <el-checkbox label="文化建设" name="area"></el-checkbox>
                  <el-checkbox label="调查研究" name="area"></el-checkbox>

                  <el-checkbox label="其他" name="area">其他
                    <el-input v-model="areaother" v-if="importInfo.service_lingyu.indexOf('其他')!==-1" class="input-type"
                              size="mini" placeholder="请填写"></el-input>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item label="运作经验：" class="margin-bottom-sm" prop="experience">
              <div class="input-container active">
                <span>该项目</span>
                <el-radio-group v-model="importInfo.experience" :max="1">
                  <el-radio label="新设立但有基础" name="type"></el-radio>
                  <el-radio label="开展1年以下" name="type"></el-radio>
                  <el-radio label="开展1-2年" name="type"></el-radio>
                  <el-radio label="开展3年以上" name="type"></el-radio>

                  <!--                  <el-radio label="其他" name="type">其他-->
                  <!--                    <el-input v-if="importInfo.experience === '其他'" class="input-type" size="mini" v-model="jyother"-->
                  <!--                              placeholder="请填写"></el-input>-->
                  <!--                  </el-radio>-->
                </el-radio-group>
              </div>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="经费预算：" class="margin-bottom-sm" prop="yusuan">
                  <div class="input-container">
                    <el-input v-model="importInfo.yusuan" placeholder="请输入金额"></el-input>
                    <span style="padding-left: 20px;">万元/年</span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="以往资金来源：" class="margin-bottom-sm" prop="source">
              <el-input type="textarea" :rows="3" resize="none" v-model="importInfo.source"
                        placeholder="请填写以往项目资金来源单位或渠道"></el-input>
            </el-form-item>
            <el-form-item label="服务地区：" class="margin-bottom-sm" prop="service_area">
              <el-input v-model="importInfo.service_area" placeholder="该项目拟开展的地区（可精确到区、街道或社区）。"></el-input>
            </el-form-item>
            <el-form-item label="项目团队：" class="margin-bottom-sm" prop="team">
              <el-input type="textarea" :rows="3" resize="none" v-model="importInfo.team"
                        placeholder="请列明直接参与该项目的工作人员，能力状况，是否专职等信息"></el-input>
            </el-form-item>
            <el-form-item label="项目简介：" class="margin-bottom-sm" prop="xiangmu_desc">
              <el-input type="textarea" :rows="9" resize="none" v-model="importInfo.xiangmu_desc"
                        placeholder="简介写作内容请说明以下方面的内容：
1.项目针对的社区需求/社会问题
2.项目对该问题/需求的解决策略
3.项目的主要内容/活动
4.项目的服务成效
5.项目的社会影响
6.项目的推广性（项目特别适用于在哪些地域/社区开展、与哪些部门/单位合作？）
7.项目特色或亮点"></el-input>
            </el-form-item>
          </el-form>
          <div class="file-tip">附件上传</div>
          <div class="file-container">
            <div class="file-title"><span>* </span>项目开展的照片3-5张：</div>
            <upFile :img-title="'xiangmu_kaizhan_img'" :accept="'image/*'" @setImg="setImg"
                     v-if="xiangmu_kaizhan_img.length<5"></upFile>
            <img class="file-box" src="../../assets/img/fileup.jpg" alt="" v-else @click="maxImg('最多上传5张图片')">
            <div class="flex-center" style="flex-wrap: wrap;flex: 1;">
              <div class="file-img-container iconfont" v-for="(item,index) in xiangmu_kaizhan_img" :key="index">
                <i class="el-icon-error" @click="delImg(0,index)"></i>
                <el-image
                  style="width: 183px; height: 130px"
                  :src="item"
                  fit="scale-down"
                  :preview-src-list="xiangmu_kaizhan_img">
                </el-image>
              </div>
            </div>

          </div>
          <div class="file-container">
            <div class="file-title">项目服务的案例1-2个：<br><span style="font-size: 12px;">(请上传配套Word和PDF文档)</span></div>
            <img class="file-box" src="../../assets/img/fileup.jpg" alt="" @click="addCase">
            <div class="file-img-container iconfont">
              <div v-for="(item,index) in xiangmu_service_img" :key="index">
                <p style="position: relative;padding: 15px;border: 1px solid #f9aa0d;margin-bottom: 10px;">
                  <a :href="item[0]" target="_blank" style="height: 30px;display: flex;align-items: center;">
                    <img src="../../assets/img/word.png" alt="" width="22px;">{{ item[0] }}
                  </a>
                  <a :href="item[1]" target="_blank" style="height: 30px;display: flex;align-items: center;">
                    <img src="../../assets/img/pdf.png" alt="" width="22px;">{{ item[1] }}
                  </a>
                  <i class="el-icon-error" @click="delImg(1,index)"
                     style="position: absolute;top:0;right:0;"></i>
                </p>
              </div>

            </div>
          </div>
          <div class="file-container">
            <div class="file-title">其他资料：<br><span style="font-size: 12px;">(请上传500M以内资料)</span></div>
            <upFile :img-title="'qita'" @setImg="setImg"></upFile>
            <div class="file-img-container iconfont" v-if="qita">
              <div>
                <p style="display: flex;align-items: center">
                  <a :href="qita" target="_blank">{{ qita }}</a>
                  <i class="el-icon-error" @click="delImg(2)"
                     style="position: relative;top:0;left:0;margin-left: 15px;"></i>
                </p>
              </div>

            </div>
          </div>
          <div class="step-title" style="padding: 20px 0">
            <div class="step-title-text">
              2.承诺函
            </div>
          </div>
          <div class="promise">
            <el-checkbox v-model="checked">
              <span style="font-size: 16px">本单位承诺，所有提交的资料内容真实有效。</span>
            </el-checkbox>
            <p>单位：{{ orgName }}</p>
            <p>日期：{{ promiseTime }}</p>
          </div>
          <div class="operate">
            <el-button class="operate-submit" @click="saveForm(0)">保存</el-button>
            <el-button class="operate-next" @click="submitFrom('importInfo')">提交</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="项目服务的案例" :visible.sync="dialogVisible" append-to-body>
      <div class="cropper-content">
        <div class="flex-center file-box-dia">
          <span>Word：</span>
          <upFile :img-title="'word'" :accept="'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.wordprocessingml.template'" @setImg="setImg"></upFile>
          <p>{{ caseArr[0] }}</p>
        </div>
        <div class="flex-center file-box-dia">
          <span>PDF：</span>
          <upFile :img-title="'pdf'" :accept="'application/pdf'" @setImg="setImg"></upFile>
          <p>{{ caseArr[1] }}</p>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import upFile2 from "../../components/upFile2";
import upFile from "../../components/upFile";

export default {
  name: "addProject",
  components: {
    upFile,
    // upFile2
  },
  data() {
    var validateAreaOther = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请选择服务领域'));
      } else {
        if (value.indexOf('其他') !== -1 && !this.areaother) {
          callback(new Error('请输入其他'));
        } else {
          callback();
        }
      }
    };
    // var validatejyOther = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请选择运作经验'));
    //   } else {
    //     if (value === '其他' && !this.jyother) {
    //       callback(new Error('请输入其他'));
    //     } else {
    //       callback();
    //     }
    //   }
    // };
    return {
      id: 0,
      orgName: '',
      promiseTime: '',
      importInfo: {
        entry_name: '',
        service_object: '',
        service_address: '',
        service_lingyu: [],
        experience: '',
        yusuan: '',
        source: '',
        service_area: '',
        team: '',
        xiangmu_desc: '',
      },
      areaother: '',
      jyother: '',
      xiangmu_kaizhan_img: [],
      xiangmu_service_img: [],
      qita: '',
      rules: {
        entry_name: [
          {required: true, message: '请输入项目名称', trigger: 'blur'},
        ],
        service_object: [
          {required: true, message: '请选择服务对象', trigger: 'blur'}
        ],
        service_address: [
          {required: true, message: '请选择服务地点', trigger: 'blur'}
        ],
        service_lingyu: [
          {type: 'array', required: true, message: '请选择服务领域', trigger: 'change'},
          {type: 'array', validator: validateAreaOther, trigger: 'change'}
        ],
        experience: [
          {required: true, message: '请选择运作经验', trigger: 'change'},
          // {validator: validatejyOther, trigger: 'change'}
        ],
        yusuan: [
          {required: true, message: '请输入金额', trigger: 'blur'}
        ],
        source: [
          {required: true, message: '请填写以往项目资金来源单位或渠道', trigger: 'blur'}
        ],
        service_area: [
          {required: true, message: '该项目拟开展的地区（可精确到区、街道或社区）。', trigger: 'blur'}
        ],
        team: [
          {required: true, message: '请列明直接参与该项目的工作人员，能力状况，是否专职等信息', trigger: 'blur'}
        ],
        xiangmu_desc: [
          {required: true, message: '请输入项目简介', trigger: 'blur'}
        ]
      },
      dialogVisible: false,
      caseArr: ['', ''],
      checked: false,
    }
  },
  created() {
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.orgName = this.$store.state.user.name
    this.promiseTime = this.$tools.ZHDate(new Date(), 4)
    this.$emit('setIndex', 2)
    if (this.id) {
      this.init()
    }

  },
  methods: {
    maxImg(str){
      this.$message.error(str)
    },
    saveForm(num) {
      let range = ''
      if (this.importInfo.service_lingyu.indexOf('其他') !== -1) {
        range = this.importInfo.service_lingyu.join(',') + ',' + this.areaother
      } else {
        range = this.importInfo.service_lingyu.join(',')
      }
      let experience = ''
      if (this.importInfo.experience === '其他') {
        experience = this.importInfo.experience + ',' + this.jyother
      } else {
        experience = this.importInfo.experience
      }
      this.$api.apiContent.applyAdd({
        token: this.$store.state.user.token,
        apply_id: this.id,
        status: num,
        service_lingyu: range,
        entry_name: this.importInfo.entry_name,
        service_object: this.importInfo.service_object,
        experience: experience,
        service_address: this.importInfo.service_address,
        yusuan: this.importInfo.yusuan,
        source: this.importInfo.source,
        service_area: this.importInfo.service_area,
        team: this.importInfo.team,
        xiangmu_desc: this.importInfo.xiangmu_desc,
        xiangmu_kaizhan_img: this.xiangmu_kaizhan_img.join(','),
        xiangmu_service_img: this.xiangmu_service_img,
        qita: this.qita
      }).then(res => {
        this.$router.push('/home/projectList')
        this.$message.success(res.msg)
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    submitFrom(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.xiangmu_kaizhan_img.length < 3) {
            return this.$message.error('请补充项目开展照片')
          }
          if (!this.checked) {
            return this.$message.error('请勾选单位承诺')
          }
          this.saveForm(1)
        } else {
          this.$message.error('信息未填写完整，请确认')
          return false;
        }
      });
    },
    init() {
      this.$api.apiContent.projectInfo({
        token: this.$store.state.user.token,
        apply_id: this.id
      }).then(res => {

        this.xiangmu_kaizhan_img = res.data.xiangmu_kaizhan_img ? res.data.xiangmu_kaizhan_img.split(',') : []
        this.xiangmu_service_img = res.data.xiangmu_service_img ? res.data.xiangmu_service_img : []
        this.qita = res.data.qita

        if (res.data.service_lingyu) {
          let range = res.data.service_lingyu.split(',')
          if (range.indexOf('其他') !== -1) {
            this.importInfo.service_lingyu = range.splice(0, range.length - 1)
            this.areaother = range[range.length - 1]
          } else {
            this.importInfo.service_lingyu = range
          }
        }
        this.importInfo.entry_name = res.data.entry_name
        this.importInfo.service_object = res.data.service_object
        this.importInfo.service_address = res.data.service_address
        if (res.data.experience) {
          let experience = res.data.experience.split(',')
          if (experience.indexOf('其他') !== -1) {
            this.importInfo.experience = experience[0]
            this.jyother = experience[1]
          } else {
            this.importInfo.experience = experience[0]
          }
        }
        this.importInfo.yusuan = res.data.yusuan
        this.importInfo.source = res.data.source
        this.importInfo.service_area = res.data.service_area
        this.importInfo.team = res.data.team
        this.importInfo.xiangmu_desc = res.data.xiangmu_desc

      }).catch(() => {
      })
    },


    addCase() {
      if (this.xiangmu_service_img.length >= 2) {
        return this.$message.error('项目服务的案例已上传2个')
      }
      this.dialogVisible = !this.dialogVisible
      this.caseArr = ['', '']
    },

    finish() {
      if (this.caseArr[0] && this.caseArr[1]) {
        this.xiangmu_service_img.push(this.caseArr)
        this.dialogVisible = !this.dialogVisible
        this.caseArr = ['', '']
      } else {
        this.$message.error('请配套上传项目服务的案例的Word及PDF')
      }

    },
    delImg(type, index) {
      let that = this
      that.$confirm('你确定要删除吗?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (type === 0) {
          that.xiangmu_kaizhan_img.splice(index, 1)
        } else if (type === 1) {
          that.xiangmu_service_img.splice(index, 1)
        } else {
          this.qita = ''
        }
      }).catch();

    },
    setImg(obj) {
      switch (obj.title) {
        case 'xiangmu_kaizhan_img':
          this.xiangmu_kaizhan_img.push(obj.url)
          return
        case 'xiangmu_service_img':
          this.xiangmu_service_img.push(obj.url)
          return
        case 'qita':
          this.qita = obj.url
          return
        case 'word':
          this.$set(this.caseArr, 0, obj.url)
          return
        case 'pdf':
          this.$set(this.caseArr, 1, obj.url)
          return
      }
    }
  }
}
</script>

<style scoped lang="scss">
.content-info {
  .form-title {
    height: 56px;
    padding: 0 30px;
    border-bottom: 2px solid #f2f2f2;
    position: relative;
    font-size: 18px;

    &:before {
      position: absolute;
      top: 17px;
      left: 15px;
      content: '';
      width: 6px;
      height: 22px;
      background-color: #f9aa0d;
    }

    span {
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #999999;
    }

    p {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;

      b {
        color: #c70005;
      }
    }
  }

  .form-step {
    padding: 20px 40px;

    span {
      width: 180px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #999999;
      background-color: #e8e8e8;
      border-radius: 21px;

      &.active {
        background-color: #f9aa0d;
        color: #fff;
      }
    }
  }

  .step-box {
    margin-top: 30px;

    .operate {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 50px;

      .operate-submit {
        width: 150px;
        height: 60px;
        background-color: #0087d4;
        border-radius: 30px;
        font-size: 16px;
        line-height: 30px;
        color: #ffffff;
      }

      .operate-next {
        width: 314px;
        height: 60px;
        margin-left: 50px;
        background-image: linear-gradient(90deg,
          #f9aa0d 0%,
          #e44730 100%),
        linear-gradient(
            #f9aa0d,
            #f9aa0d);
        background-blend-mode: normal,
        normal;
        border-radius: 30px;
        font-size: 16px;
        line-height: 30px;
        color: #ffffff;
      }
    }

    .file-container {
      display: flex;
      flex-direction: row;
      min-height: 185px;
      border: 1px solid #eeeeee;
      align-items: center;

      .file-box {
        display: block;
        width: 131px;
        height: 131px;
      }

      .file-title {
        width: 200px;
        font-size: 16px;
        text-align: right;
        margin-right: 15px;

        span {
          color: red;
        }
      }

      .file-up {
        flex-shrink: 0;
        width: 131px;
        height: 131px;
        margin-left: 14px;
      }

      .file-img-container {
        margin: 10px;
        position: relative;

        i {
          font-size: 26px;
          color: #f9aa0d;
          position: absolute;
          top: -15px;
          right: -15px;
          cursor: pointer;
          z-index: 99;
        }

        .file-img {
          width: 183px;
          height: 130px;
        }
      }

    }

    .file-tip {
      width: 100%;
      height: 50px;
      font-size: 16px;
      line-height: 50px;
      padding-left: 36px;
      background-color: #ffe6e7;
    }

    .input-container {
      display: flex;
      flex-direction: row;
      align-items: center;

      &.active {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        padding: 0 12px;
      }

      .input-type {
        width: 120px;
        height: 27px;
      }

      span {
        margin-right: 20px;
        flex-shrink: 0;
      }
    }

    .step-title {
      .step-title-text {
        width: 179px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        font-size: 18px;
        font-weight: normal;
        font-style: italic;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        background: url(../../assets/img/title.png) no-repeat center;
      }

      .step-title-tips {
        flex: 1;
        padding: 10px;
        line-height: 16px;
        font-size: 12px;
        background-color: #fff4f4;
        border-radius: 4px;
        border: solid 1px #ffe8e8;
        color: #c70005;

        span {
          color: #999;
        }
      }
    }

    .promise {
      width: 800px;
      margin: 30px auto 0;
      padding-left: 50px;

      p {
        line-height: 40px;
        font-size: 16px;
        font-weight: 500;
        margin-top: 10px;
        padding-left: 200px;
      }
    }
  }
}

.file-box-dia {
  margin-bottom: 30px;

  span {
    display: block;
    width: 80px;
    text-align: right;
  }

  p {
    display: block;
    flex: 1;
    margin: 0 30px;
  }
}
</style>
